module.exports = __webpack_public_path__ + "img/introduce2.a26be144.png";